import styled from 'styled-components';

const StyledBarGroupChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${(props) => props.theme.colors.light};
  display: flex;
  flex-direction: column;
`;

const LegendWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
`;

const LegendCircle = styled.div`
  width: 16px;
  background: ${(props) => props.color};
  border-radius: 8px;
  height: 16px;
`;

const LegendText = styled.div`
  font-size: 11px;
  font-weight: normal;
  padding-left: 10px;
`;

export { StyledBarGroupChartWrapper, LegendWrapper, LegendCircle, LegendText };
